import { useTranslation } from "react-i18next";

import { CountryIsoCode } from "../add-address/useCountryISO2Code";
import { FundsOrigin, PurchaseStatus, Transaction } from "./useTransactions";

const useTransactionTag = ({
  state,
  rejectedReason,
  fundOrigins,
  isCountryLoading,
  countryISO2Code,
}: {
  state: Transaction["state"];
  fundOrigins: Transaction["fundOrigins"];
  rejectedReason: Transaction["rejectedReason"];
  isCountryLoading: boolean;
  countryISO2Code: CountryIsoCode;
}) => {
  const { t } = useTranslation();

  const getRejectedTag = () => {
    if (state !== PurchaseStatus.REJECTED) return null;
    const description = rejectedReason
      ? t(`transactions.rejected-reasons.${rejectedReason}`)
      : t("transactions.rejected-reasons.unknown-error");

    return `${t("transactions.purchase-status.rejected")}: ${description}`;
  };
  const translateForFromCompanyFundsOrigin = {
    [CountryIsoCode.SPAIN]: t("transactions.label-type.paid-by-company"),
    [CountryIsoCode.MEXICO]: t("transactions.label-type.consumption-subsidy"),
    [CountryIsoCode.PORTUGAL]: t("transactions.label-type.consumption-subsidy"),
  };

  const transactionTagByFundOrigin = (
    isCountryLoading: boolean,
    country: CountryIsoCode
  ) => ({
    [FundsOrigin.FROM_BENEFIT_BAG]: t(
      "transactions.label-type.paid-by-benefit-bag"
    ),
    [FundsOrigin.FROM_COMPANY]: isCountryLoading
      ? ""
      : translateForFromCompanyFundsOrigin[country],
    [FundsOrigin.FROM_SALARY]: t("transactions.label-type.paid-by-salary"),
    [FundsOrigin.FROM_ACCUMULATED_ALLOWANCE]: t(
      "transactions.label-type.accumulated"
    ),
    [FundsOrigin.FROM_ACCUMULATED_SALARY]: t(
      "transactions.label-type.accumulated"
    ),
    shared: t("transactions.label-type.shared-payment"),
  });

  const rejectedTag = getRejectedTag();

  if (rejectedTag) return rejectedTag;

  if (state === PurchaseStatus.CANCELLED) {
    return t("transactions.purchase-status.cancelled");
  }

  const fundOriginItem = fundOrigins?.length > 1 ? "shared" : fundOrigins[0];
  const tagToReturn = transactionTagByFundOrigin(
    isCountryLoading,
    countryISO2Code
  )[fundOriginItem];

  return tagToReturn || "";
};

export { useTransactionTag };
